import React from 'react';
import { Header, Icon, Segment, List, Button } from 'semantic-ui-react';

import { renderListItem } from '../../helper/notification-helper.js';

class NotificationObserver extends React.Component {

  render() {
    return (
      <div>
      <Header attached='top'>
        <Icon.Group size='big'>
          <Icon name='flag' />
          <Icon corner name='database' />
        </Icon.Group>
        <Header.Content>
          All recent changes at actioncy.io
        </Header.Content>
      </Header>
      <Segment attached loading={this.props.loading}>
        <List divided relaxed>
          {
            Object.keys(this.props.recentChanges)
            .reverse()
            .map( key => renderListItem(this.props.recentChanges[key], key))
          }
        </List>
      </Segment>
      <Button
        active={!this.props.loading}
        attached='bottom'
        onClick={this.props.clickCallback}
        >
        <Icon name='plus' />
        Show More
      </Button>
    </div>
    );
  }

}

export default NotificationObserver;



// WEBPACK FOOTER //
// ./src/components/protected/NotificationObserver.js